!(function (Helpers, $, undefined) {
  "use strict";

  $(".logo_carousel_wrapper").flickity({
    cellAlign: "left",
    cellSelector: ".logo_carousel_item-item",
    contain: true,
    pageDots: false,
    imagesLoaded: true,
  });

  $(".featured_collection_card-carousel").flickity({
    cellAlign: "left",
    cellSelector: ".featured_collection_card-carousel-item",
    contain: true,
    pageDots: false,
    imagesLoaded: true,
  });

  $(".pb-product_carousel").flickity({
    cellAlign: "left",
    cellSelector: ".featured_collection_card-carousel-cell",
    contain: true,
    pageDots: false,
    imagesLoaded: true,
    watchCSS: true,
  });

  // Append .background-image-holder <img>'s as CSS backgrounds
  var initBackgroundImages = function () {
    $(".background-image-holder").each(function () {
      var imgSrc = $(this).children("img").attr("src");
      $(this).css("background", 'url("' + imgSrc + '")');
      $(this).children("img").hide();

      $(this).css("background-position", "initial");
    });
    // Fade in background images
    setTimeout(function () {
      $(".background-image-holder").each(function () {
        $(this).addClass("fadeIn");
      });
    }, 200);
  };

  var bindUIActions = function () {
    if (message_text_carousel) {
      $(".message_text-carousel").flickity({
        cellAlign: "center",
        cellSelector: ".message_text-item",
        contain: false,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
      });
    }
    $("#atc_shipsaver").click(function (e) {
      e.preventDefault();
      var variantId = $(this).attr("data-variant_id");
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        data: {
          quantity: 1,
          id: variantId,
        },
        success: function (data) {
          $("#atc_shipsaver").replaceWith(
            '<div class="added"><strong>Added to your cart.</strong></div>'
          );
          window.location.reload();
        },
        error: function (XMLHttpRequest, textStatus) {
          alert(
            "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
          );
        },
      });
    });

    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var $top_nav = $("#top_nav");
    var top_nav_height = $top_nav.height();
    var top_nav_top = $top_nav.position().top;
    //var top_nav =

    var checkScroll = function () {
      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      } else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }
      toggleHeader(direction, curScroll);
      prevScroll = curScroll;
    };

    var toggleHeader = function (direction, curScroll) {
      if (direction == 2) {
        var top_banner_height = $(".top-banner").outerHeight() * -1;
        $(".top-banner").addClass("scrolled");
        $("#nav_wrapper").css("top", top_banner_height);
      }
      if (direction == 1) {
        if (curScroll > 10) {
          $(".top-banner").removeClass("scrolled");
          $("#nav_wrapper").css("top", 0);
        }
      }
    };
    window.addEventListener("scroll", checkScroll);

    $(document).on("keydown", function (event) {
      if (event.keyCode === 27) {
        close_mobile_menu();
      }
    });

    $(".btn-close, .screen-overlay").click(function (e) {
      close_mobile_menu();
    });

    $(".close_top_banner").click(function (e) {
      e.preventDefault();
      $(".top-banner").addClass("d-none");
      $("body").addClass("no-display_announcement");
    });
    $(".link_w_tooltip").tooltip({
      trigger: "click hover focus",
    });
    var currentWidth = $(window).width();
    var flickityEnabled = false;

    function close_mobile_menu() {
      $("#offcanvas-toggler").removeClass("is-active");
      $("#mobile-offcanvas").removeClass("show");
      $("body").removeClass("offcanvas-active");
      $(".screen-overlay").removeClass("show");
    }

    function open_mobile_menu() {
      var paddingTop = $("#nav_wrapper").height();
      $("#offcanvas-toggler").addClass("is-active");
      $("#mobile-offcanvas").css("padding-top", paddingTop);
      $("#mobile-offcanvas").addClass("show");
      $("body").addClass("offcanvas-active");
      $(".screen-overlay").addClass("show");
    }
    $("#offcanvas-toggler").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      //var menuPosition = $('.menu_wrapper').offset().top + $('.menu_wrapper').outerHeight(true);
      if ($("body").hasClass("offcanvas-active")) {
        close_mobile_menu();
      } else {
        open_mobile_menu();
      }
    });

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    ) {
      $(".gm-select").selectpicker({
        mobile: true,
        virtualScroll: false,
      });
    } else {
      $(".gm-select").selectpicker({
        virtualScroll: false,
        container: "body",
      });
    }
    $(".selector-wrapper label").click(function (e) {
      e.preventDefault();
      var selectedEl = $(this).attr("for");
      $("#" + selectedEl).selectpicker("toggle");
    });

    $(".l1_icon_nav").click(function (e) {
      e.preventDefault();
      if ($(this).hasClass("l1_icon_nav_right")) {
        $(".menu_wrapper").animate(
          {
            scrollLeft: "+=153",
          },
          500
        );
      } else {
        $(".menu_wrapper").animate(
          {
            scrollLeft: "-=153",
          },
          500
        );
      }
    });
  };
  Helpers.init = function () {
    initBackgroundImages();
    bindUIActions();
  };
})((window.Helpers = window.Helpers || {}), jQuery),
  (function (Cart, $, undefined) {
    var bindUIActions = function () {
      $(".card_promo_carousel").flickity({
        cellAlign: "left",
        cellSelector: ".card_promo_carousel-item",
        contain: true,
        pageDots: false,
        imagesLoaded: true,
      });

      function updateTotalSavings(cart) {
        let totalSavings = 0;

        // biome-ignore lint/complexity/noForEach: <explanation>
        cart.items.forEach((item, index) => {
          const item_strikethrough = document.querySelector(
            `.item-price[data-strikethrough-${index}]`
          );

          if (item_strikethrough) {
            // biome-ignore lint/style/useNumberNamespace: <explanation>
            const compareAtPrice = parseFloat(
              item_strikethrough.getAttribute(`data-strikethrough-${index}`)
            );

            //update line strikethroug price

            const line_strikethroug = (compareAtPrice * item.quantity) / 100;
            const formatted_line_strikethroug = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(line_strikethroug);

            item_strikethrough.textContent = formatted_line_strikethroug;

            // biome-ignore lint/style/useNumberNamespace: <explanation>
            const finalPrice = parseFloat(item.original_line_price);
            const itemSaving = compareAtPrice * item.quantity - finalPrice;
            totalSavings += itemSaving;
          }
        });

        let cartDiscounts = cart.total_discount;

        totalSavings = totalSavings / 100;

        if (cartDiscounts) {
          cartDiscounts = cartDiscounts / 100;
          totalSavings = totalSavings + cartDiscounts;
        }

        const savingsContainer = document.querySelector(
          ".cart-page .total-savings__container"
        );

        if (totalSavings > 0) {
          const formattedSavings = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(totalSavings);

          if (!savingsContainer.querySelector(".total-savings-text")) {
            const textSpan = document.createElement("span");
            textSpan.className = "total-savings-text";
            textSpan.textContent = "Total Savings:";
            savingsContainer.appendChild(textSpan);
          }

          let amountSpan = savingsContainer.querySelector(
            ".total-savings-amount"
          );
          if (!amountSpan) {
            amountSpan = document.createElement("span");
            amountSpan.className = "total-savings-amount";
            savingsContainer.appendChild(amountSpan);
          }

          amountSpan.textContent = formattedSavings;
          savingsContainer.style.display = "flex";
        } else {
          savingsContainer.style.display = "none";
        }
      }

      function update_item(new_qty, lineItemKey, parentEl, qtyEl, reload) {
        var data = {
          quantity: new_qty,
          id: lineItemKey,
        };
        jQuery.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: data,
          dataType: "json",
          error: function (XMLHttpRequest, textStatus) {
            console.log(XMLHttpRequest, textStatus);
            console.log(textStatus);
          },
          success: function (response) {
            if (reload) {
              window.location.reload();
            }
            var workingLineItem = _.find(response.items, function (item) {
              console.log("lineItemKey123", lineItemKey, item.key);
              return item.variant_id == lineItemKey;
            });
            var wwfw_items = _.filter(response.items, function (item) {
              return (
                item.product_type === "Clothing" ||
                item.product_type === "Footwear"
              );
            });
            if (wwfw_items.length >= 1)
              var wwfw_total = _.reduce(
                wwfw_items,
                function (memo, item) {
                  return memo + item.final_line_price;
                },
                0
              );
            var shipping_thresheold = $(".promo_clothing_card .card-body").attr(
              "data-shipping_threshold"
            );
            var shippign_check = shipping_thresheold - wwfw_total;
            if (shippign_check > 0) {
              var shipping_msg =
                "<p>You are " +
                Shopify.formatMoney(shippign_check) +
                ' away from Free Shipping! Shop more <a href="/collections/clothing">clothing</a> ';
              shipping_msg +=
                'or <a href="/collections/footwear">footwear</a> to add eligible products to your cart.</p>';
            } else {
              var shipping_msg =
                "<p><strong>You're eligible for free shipping!</strong></p>";
              shipping_msg +=
                "<p>Valid for $50+ Orders of Only Clothing and Footwear</p>";
            }
            $(".promo_clothing_card .card-body .pcc-txt").html(shipping_msg);

            parentEl
              .find(".item-price")
              .text(Shopify.formatMoney(workingLineItem.final_line_price));
            // parentEl
            //   .find(".item-original-price")
            //   .text(Shopify.formatMoney(workingLineItem.original_line_price));

            // .text(
            //   Shopify.formatMoney(
            //     parentEl
            //       .find(".item-original-price")
            //       .data("compare_at_price") * workingLineItem.quantity
            //   )
            // );

            updateTotalSavings(response);

            $(".subtotal_price").text(
              Shopify.formatMoney(response.total_price)
            );

            // sync header count + drawer with the new quantity
            if (!reload) {
              window.cartContents = response;
              if (typeof updateCartItemCounts === "function") {
                updateCartItemCounts(response.item_count);
              }
              if (typeof updateCartDrawer === "function") {
                updateCartDrawer();
              }
            }
          },
        });
      }

      $(".product-cart-item").on("change", ".quantity", function () {
        var parentEl = $(this).closest(".media");
        var lineItemKey = parentEl.attr("data-key");
        var new_qty = $(this).val();
        update_item(new_qty, lineItemKey, parentEl, $(this));
      });

      $(".product-cart-item").on(
        "click",
        ".cart-drawer-quantity-selector-minus",
        function () {
          var parentEl = $(this).closest(".media");
          var lineItemKey = parentEl.attr("data-key");
          var new_qty = Number($(this).siblings(".quantity").val()) - 1;
          if (new_qty < 0) {
            new_qty = 0;
          }
          $(this).siblings(".quantity").val(new_qty);
          update_item(
            new_qty,
            lineItemKey,
            parentEl,
            $(this).siblings(".quantity")
          );
          if (new_qty === 0) {
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        }
      );

      $(".product-cart-item").on(
        "click",
        ".cart-drawer-quantity-selector-plus",
        function () {
          var parentEl = $(this).closest(".media");
          var lineItemKey = parentEl.attr("data-key");
          var new_qty = Number($(this).siblings(".quantity").val()) + 1;
          $(this).siblings(".quantity").val(new_qty);
          update_item(
            new_qty,
            lineItemKey,
            parentEl,
            $(this).siblings(".quantity")
          );
        }
      );

      $(".product-cart-item").on(
        "click",
        ".cart-drawer-quantity-selector-remove",
        function (e) {
          e.preventDefault();
          var parentEl = $(this).closest(".media");
          var lineItemKey = parentEl.attr("data-key");
          var new_qty = 0;
          update_item(
            new_qty,
            lineItemKey,
            parentEl,
            $(this).siblings(".quantity"),
            true
          );
        }
      );

      $(".qty-selector").change(function (e) {
        e.preventDefault();
        var parentEl = $(this).closest(".media");
        var lineItemKey = parentEl.attr("data-key");
        var new_qty = $(this).find("option:selected").val();
        if (new_qty == "10_plus") {
          $(".dropdown.show").removeClass("show").hide();
          var new_el =
            '<div class="form-group selector-wrapper">\
        <label for="quantity"> Quantity </label>\
        <input type="number" value="10" class="form-control" id="quantity" name="quantity"/>\
        </div>';
          $(this).replaceWith(new_el);
          update_item(10, lineItemKey, parentEl, $(this));
        }
      });
    };
    Cart.init = function () {
      bindUIActions();
    };
  })((window.Cart = window.Cart || {}), jQuery),
  (function (Collections, $, undefined) {
    Collections.init = function () {
      //bindUIActions();
    };
  })((window.Collections = window.Collections || {}), jQuery),
  (function (ProductPage, $, undefined) {
    ProductPage.product = false;
    ProductPage.variants = false;
    ProductPage.current_variant = false;
    ProductPage.cart = false;

    Shopify.optionsMap = {};
    Shopify.discountMap = {};

    Shopify.arrayIncludes = function (t, e) {
      for (var o = 0; o < t.length; o++) {
        if (t[o] == e) return !0;
      }
      return !1;
    };

    Shopify.uniq = function (t) {
      for (var e = [], o = 0; o < t.length; o++) {
        Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
      }
      return e;
    };

    Shopify.updateDiscountsInSelector = function (step) {
      $(".gm-select").selectpicker("refresh");
    };

    Shopify.updateOptionsInSelector = function (selectorIndex) {
      switch (selectorIndex) {
        case 0:
          var key = "root";
          var selector = jQuery(".single-option-selector:eq(0)");
          break;
        case 1:
          var key = jQuery(".single-option-selector:eq(0) input:checked").val();
          var selector = jQuery(".single-option-selector:eq(1)");
          break;
        case 2:
          var key = jQuery(".single-option-selector:eq(0) input:checked").val();
          key +=
            " / " + jQuery(".single-option-selector:eq(1) input:checked").val();
          var selector = jQuery(".single-option-selector:eq(2)");
      }
      var initialValue = selector.find("input:checked").val();
      var availableOptions = Shopify.optionsMap[key];
      selector.find("input").each(function () {
        var $this = jQuery(this);
        var _value = $this.val();
        if (jQuery.inArray(_value, availableOptions) !== -1) {
          $this.removeAttr("disabled", "disabled").html(_value);
        } else {
          $this.removeAttr("checked", "checked").attr("disabled", "disabled");
        }
      });
      if (
        selector.find(":checked").length < 1 ||
        selector.find(":checked").attr("disabled") === "disabled"
      ) {
        selector
          .find("input:not(:disabled)")
          .first()
          .prop("checked", "checked")
          .change();
      }
      if (jQuery.inArray(initialValue, availableOptions) !== -1) {
        selector.find("input:checked").val(initialValue);
      }
      var selectedVal = selector.find("input:checked").val();
      if (selectedVal == null) {
        selector
          .find("input:not(:disabled)")
          .first()
          .prop("checked", "checked")
          .change();
      }
      $(".gm-select").selectpicker("refresh");
    };
    Shopify.linkOptionSelectors = function (product) {
      // Building our mapping object.
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
          if (variant.compare_at_price) {
            Shopify.discountMap[variant.option1] =
              Shopify.discountMap[variant.option1] || [];
            if (product.options.length > 1) {
              Shopify.discountMap[variant.option1].push(variant.option2);
              Shopify.discountMap[variant.option1] = Shopify.uniq(
                Shopify.discountMap[variant.option1]
              );
            }
            if (product.options.length == 3) {
              var key = variant.option1 + " / " + variant.option2;
              Shopify.discountMap[key] = Shopify.discountMap[key] || [];
              Shopify.discountMap[key].push(variant.option3);
              Shopify.discountMap[key] = Shopify.uniq(Shopify.discountMap[key]);
            }
          }

          // Gathering values for the 1st drop-down.
          Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
          Shopify.optionsMap["root"].push(variant.option1);
          Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option2);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option3);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }
        }
      }
      // Update options right away.
      if (product.options.length == 1) {
        Shopify.updateOptionsInSelector(0);
        Shopify.updateDiscountsInSelector(0);
      } else {
        Shopify.updateOptionsInSelector(0);
        Shopify.updateDiscountsInSelector(0);
        if (product.options.length > 1) {
          Shopify.updateOptionsInSelector(1);
          Shopify.updateDiscountsInSelector(1);
        }
      }

      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      // When there is an update in the first dropdown.
      jQuery(".single-option-selector:eq(0) input").change(function () {
        Shopify.updateOptionsInSelector(1);
        Shopify.updateDiscountsInSelector(1);
        if (product.options.length === 3) {
          Shopify.updateOptionsInSelector(2);
          Shopify.updateDiscountsInSelector(2);
        }
        return true;
      });
      // When there is an update in the second dropdown.
      jQuery(".single-option-selector:eq(1) input").change(function () {
        if (product.options.length === 3) {
          Shopify.updateOptionsInSelector(2);
          Shopify.updateDiscountsInSelector(2);
        }
        return true;
      });
      $(".single-option-selector input").trigger("change");
    };

    var pdp_utilities = function () {
      var $addToCartForm = $('form[action="/cart/add"]');
      var product = JSON.parse(
        document.getElementById("ProductJson").innerHTML
      );
      if (product && product.available && product.options.length >= 1) {
        if (window.MutationObserver && $addToCartForm.length) {
          if (
            typeof observer === "object" &&
            typeof observer.disconnect === "function"
          ) {
            observer.disconnect();
          }
          var config = {
            childList: true,
            subtree: true,
          };
          var observer = new MutationObserver(function () {
            Shopify.linkOptionSelectors(product);
            observer.disconnect();
          });
          observer.observe($addToCartForm[0], config);
        }
        Shopify.linkOptionSelectors(product);
      }
    };

    var updatePrice = function () {
      var customerEligible = ProductPage.discountData.customer_eligible;
      var productEligible =
        ProductPage.discountProductEligibleData.product_eligible;
      var mapPricingTagExists =
        ProductPage.product.tags.includes("map_pricing_T");
      var priceMultiplier = ProductPage.discountData.price_multiplier;

      $(".on-sale").remove();
      var productPrice = ProductPage.current_variant.price;
      var originalPrice =
        ProductPage.current_variant.compare_at_price || productPrice;
      if (customerEligible && productEligible && !mapPricingTagExists) {
        productPrice = originalPrice * priceMultiplier; // Apply the multiplier to the original price
      }
      $("[product-price]").html(Shopify.formatMoney(productPrice));
      if (productPrice < originalPrice) {
        var savePrice = originalPrice - productPrice;
        var percentSavePrice = Math.round((savePrice * 100) / originalPrice);
        $("[original-price]").html(Shopify.formatMoney(originalPrice));
        if (!customerEligible || !productEligible) {
          $("#ProductPrice").append(
            '<span class="on-sale">Save ' + percentSavePrice + "%</span>"
          );
          $("[original-price]").removeClass("d-none");
        }
      } else {
        $("[original-price]").addClass("d-none");
      }
    };

    var updateImage = function () {
      if (ProductPage.current_variant.featured_image) {
        var index = ProductPage.current_variant.featured_image.position - 1; // will give you 2
        $(".carousel-mip").flickity("select", index);
      }
    };

    var updateHistoryState = function () {
      // Update history state for product deeplinking
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        ProductPage.current_variant.id;
      window.history.replaceState(
        {
          path: newurl,
        },
        "",
        newurl
      );
    };

    var getProductOptions = function () {
      var currentOptions = jQuery.map(
        $("[single-product-selector]"),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};
          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );
      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);
      //console.log(currentOptions);
      return currentOptions;
    };

    var getCurrentVariant = function (variantId) {
      var variants = ProductPage.product.variants;
      // map variants and return the selected one
      var found = jQuery.map(variants, function (variant) {
        if (variant.id == variantId) {
          return variant; // return matching variant object
        }
      });
      return found[0]; // returns single array so pull out first element object
    };
    var product_type = ProductPage.product.type;
    var check_extra_properties_upsell = function (product_tags) {
      console.log({
        product_tags,
      });
      var stock_status = false;
      if (product_tags.includes("shipping_truck_T")) {
        var stock_status = {
          name: "truck",
          value: "Standard Freight.",
        };
      }
      if (product_tags.includes("shipping_hazardous_T")) {
        var stock_status = {
          name: "haz",
          value: "Hazardous Shipping.",
        };
      }

      if (
        product_tags.includes("map_pricing_T") ||
        product_tags.includes("price_discount_allowed_F")
      ) {
        var stock_status = {
          name: "map",
          value: "Not eligible for promo.",
        };
      }

      return stock_status;
    };

    var check_extra_properties = function (formData) {
      var product_type = ProductPage.product.type;
      var product_tags = ProductPage.product.tags;
      if (product_tags.includes("shipping_truck_T")) {
        var stock_status = {
          name: "properties[_truck]",
          value: "Standard Freight.",
        };
        formData.unshift(stock_status);
      }
      if (product_tags.includes("shipping_hazardous_T")) {
        var stock_status = {
          name: "properties[_haz]",
          value: "Hazardous Shipping.",
        };
        formData.unshift(stock_status);
      }
      if (product_type.includes("Free Gifts")) {
      } else {
        if (
          product_tags.includes("map_pricing_T") ||
          product_tags.includes("price_discount_allowed_F")
        ) {
          var stock_status = {
            name: "properties[_map]",
            value: "Not eligible for promo.",
          };
          formData.unshift(stock_status);
        }
      }
      if (ProductPage.current_variant_details.ffi === "T") {
        var stock_status = {
          name: "properties[_ffi]",
          value:
            "This product is not eligible for Free Shipping or Ship Saver.",
        };
        formData.unshift(stock_status);
      }
      return formData;
    };

    function isNumber(char) {
      return /^\d$/.test(char);
    }

    // function parseDateString(dateString) {
    //       let [weekday, month, day, year] = dateString.split(' ');
    //       console.log('aaa', dateString);
    //       const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    //       month = months.indexOf(month) + 1;
    //       day = parseInt(day.replace(',', ''));
    //       year = parseInt(year);
    //       return new Date(year, month - 1, day);
    // }

    function parseDateString(dateString) {
      function parseLongDateFormat(dateString) {
        let [weekday, month, day, year] = dateString.split(" ");
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        month = months.indexOf(month) + 1;
        day = parseInt(day.replace(",", ""));
        year = parseInt(year);
        return new Date(year, month - 1, day);
      }

      function parseShortDateFormat(dateString) {
        let [month, day, year] = dateString.split("/");
        month = parseInt(month);
        day = parseInt(day);
        year = parseInt(year);
        return new Date(year, month - 1, day);
      }

      if (dateString.includes(",")) {
        return parseLongDateFormat(dateString);
      } else {
        return parseShortDateFormat(dateString);
      }
    }

    var setUpProductPage = function () {
      if (
        ProductPage.current_variant_details.stock_status.includes(
          "Backorder - Ships "
        )
      ) {
        if (!ProductPage.current_variant_details.moment) {
          let stock_status = ProductPage.current_variant_details.stock_status;
          let stockDate = stock_status.split("Backorder - Ships ")[1];
          if (!isNumber(stockDate[0])) {
            let date = parseDateString(stockDate);
            const yyyy = date.getFullYear();
            let mm = date.getMonth() + 1;
            let dd = date.getDate();
            const formattedDate = mm + "/" + dd + "/" + yyyy;
            window.momentRan = true;
            ProductPage.current_variant_details.stock_status =
              "Backorder - Ships " + formattedDate;
            ProductPage.current_variant_details.moment = true;
          }
        }
      }

      if (
        ProductPage.current_variant_details.alt_stock_status.includes(
          "Backorder - Ships "
        )
      ) {
        if (!ProductPage.current_variant_details.alt_moment) {
          let stock_status =
            ProductPage.current_variant_details.alt_stock_status;
          let stockDate = stock_status.split("Backorder - Ships ")[1];
          let date = parseDateString(stockDate);
          const yyyy = date.getFullYear();
          let mm = date.getMonth() + 1;
          let dd = date.getDate();
          const formattedDate = mm + "/" + dd + "/" + yyyy;
          ProductPage.current_variant_details.alt_stock_status =
            "Backorder - Ships " + formattedDate;
          ProductPage.current_variant_details.alt_moment = true;
        }
      }
      variant = ProductPage.current_variant;
      var cart_variants = _.where(ProductPage.cart.items, {
        variant_id: variant.id,
      });

      if (cart_variants.length > 0) {
        var cart_qty = _.pluck(cart_variants, "quantity");
        var cart_qty = _.reduce(
          cart_qty,
          function (memo, num) {
            return memo + num;
          },
          0
        );

        ProductPage.current_variant_details.inventory_quantity =
          ProductPage.current_variant_details.variant_quantity - cart_qty;
      }

      //Show/hide badges

      $(".badge-name").hide();
      // console.log( '53m1c',ProductPage.current_variant_details);
      if (ProductPage.current_variant_details.on_hot_deal) {
        $(".ships-hot-deal").show();
      } else if (ProductPage.current_variant_details.on_ships_free) {
        $(".ships-free-badge").show();
        $(".shipping-badge_wrapper").removeClass("hidden");
      } else if (ProductPage.current_variant_details.on_closeout) {
        $(".close-out-badge").show();
      } else if (ProductPage.current_variant_details.on_sale) {
        $(".sale-badge").show();
      } else if (ProductPage.current_variant_details.on_new) {
        $(".new-badge").show();
      } else if (ProductPage.current_variant_details.on_usa_made) {
        $(".usa-made-badge").show();
      } else if (ProductPage.current_variant_details.on_logo_add_badge) {
        $(".add-logo-badge").show();
      }

      if (ProductPage.current_variant_details.clearance_msg) {
        $(".clearance")
          .html(ProductPage.current_variant_details.clearance_msg)
          .show();
      } else {
        $(".clearance").hide();
      }

      if (ProductPage.current_variant_details.dropShip === "T") {
        $(".dropshipMessage")
          .html(ProductPage.current_variant_details.dropshipMessage)
          .show();
      } else {
        $(".dropshipMessage").hide();
      }

      if (
        ProductPage.current_variant_details.web_backorder_notes.toLowerCase() !=
        "false"
      ) {
        $(".web_backorder_notes")
          .html(ProductPage.current_variant_details.web_backorder_notes)
          .show();
      } else {
        $(".web_backorder_notes").hide();
      }

      let qtyDiscountEvent = new CustomEvent("qtyDiscountEvent", {
        detail: { key: "value" }, // dummy
      });

      window.dispatchEvent(qtyDiscountEvent);

      $("#variant_brand_id").text(ProductPage.current_variant_details.brand_id);
      $("#variant_sku_txt").text(ProductPage.current_variant_details.sku);
      $("#skuprop").val(ProductPage.current_variant_details.sku);
      $(".js-selected-option-0, .js-sticky-option .option1").text(
        ProductPage.current_variant.option1
      );
      $(".js-selected-option-1, .js-sticky-option .option2").text(
        ProductPage.current_variant.option2
      );
      $(".js-selected-option-2, .js-sticky-option .option3").text(
        ProductPage.current_variant.option3
      );
      if (
        ProductPage.current_variant_details.web_backorder_notes.toLowerCase() ==
        "false"
      ) {
        $("#web_backorder_notes").text("").hide();
        $("#stock_status_msg")
          .text(ProductPage.current_variant_details.stock_status)
          .show();
        //Change ATC to Backorder
        $(".btn-atc span").text(
          ProductPage.current_variant_details.stock_status
        );
      } else {
        if (ProductPage.current_variant_details.variant_quantity <= 0) {
          ProductPage.current_variant_details.stock_status =
            ProductPage.current_variant_details.web_backorder_notes;
        }
        $("#stock_status_msg")
          .text(ProductPage.current_variant_details.stock_status)
          .show();
        $("#web_backorder_notes").text("").hide();
      }

      if (ProductPage.current_variant_details.clearance_msg != "false") {
        $("#clearance_msg")
          .text(ProductPage.current_variant_details.clearance_msg)
          .show();
      } else {
        $("#clearance_msg").text("").hide();
      }

      if (ProductPage.current_variant_details.ffi == "T") {
        $("#product_ffi")
          .text("This product is not eligible for Free Shipping or Ship Saver")
          .show();
      } else {
        $("#product_ffi").text("").hide();
      }
      $("#quantity").attr(
        "data-avail_qty",
        ProductPage.current_variant_details.inventory_quantity
      );
      if (ProductPage.current_variant_details.sds) {
        $("#pdp_safety_data_sheet_link").attr(
          "href",
          ProductPage.current_variant_details.sds
        );
      }
      if (
        ProductPage.current_variant_details.inventory_policy == "deny" &&
        ProductPage.current_variant_details.inventory_quantity <= 0
      ) {
        $(".btn-atc").attr("disabled", "disabled");
        $(".btn-atc span").text("Sold out");
        $("#stock_status_msg").text("");
        if (!$("#ProductPrice").hasClass("sold_out_badge_active")) {
          $("#ProductPrice").append(
            '<span class="plp_sold_out_badge">Sold out</span'
          );
          $("#ProductPrice").addClass("sold_out_badge_active");
        }
      } else if (
        ProductPage.current_variant_details.web_backorder_notes.toLowerCase() ==
          "false" &&
        ProductPage.current_variant_details.inventory_quantity <= 0 &&
        ProductPage.current_variant_details.dropShip != "T" &&
        ProductPage.product.id != 2043742617689
      ) {
        $(".btn-atc").attr("disabled", null);
        $(".plp_sold_out_badge").remove();
        $(".btn-atc span").text(
          ProductPage.current_variant_details.alt_stock_status
        );
        $("#ProductPrice").removeClass("sold_out_badge_active");
      } else if (
        ProductPage.current_variant_details.web_backorder_notes.toLowerCase() ==
          "false" &&
        ProductPage.current_variant_details.inventory_quantity <= 0 &&
        ProductPage.current_variant_details.dropShip == "T"
      ) {
        $(".btn-atc").attr("disabled", null);
        $(".plp_sold_out_badge").remove();
        $(".btn-atc span").text(
          ProductPage.current_variant_details.stock_status
        );
        $("#ProductPrice").removeClass("sold_out_badge_active");
      } else if (
        ProductPage.current_variant_details.inventory_quantity <= 0 &&
        ProductPage.current_variant_details.dropShip == "T"
      ) {
        $(".btn-atc").attr("disabled", null);
        $(".plp_sold_out_badge").remove();
        $(".btn-atc span").text(
          ProductPage.current_variant_details.alt_stock_status
        );
        $("#ProductPrice").removeClass("sold_out_badge_active");
      } else if (
        ProductPage.current_variant_details.web_backorder_notes.toLowerCase() !==
          "false" &&
        ProductPage.current_variant_details.inventory_policy !== "deny"
      ) {
        $(".btn-atc").attr("disabled", null);
        $(".plp_sold_out_badge").remove();
        if (ProductPage.current_variant_details.on_preorder) {
          $(".btn-atc span").text("Preorder");
        } else {
          $(".btn-atc span").text("BACKORDER");
        }
        $("#ProductPrice").removeClass("sold_out_badge_active");
      } else {
        $(".btn-atc").attr("disabled", null);
        $(".plp_sold_out_badge").remove();
        $(".btn-atc span").text("In Stock - Add To Cart");
        $("#ProductPrice").removeClass("sold_out_badge_active");
      }

      var instockMessage = $(".special-message p").filter(function() {
        return $(this).text().includes("In stock orders placed before 3pm CST will ship the same day");
      });
      
      var isShipSaverProduct = ProductPage.product.id == 2043742617689;
      var isBackorder = ProductPage.current_variant_details.inventory_quantity <= 0 && 
                       ProductPage.current_variant_details.dropShip !== "T" && 
                       !isShipSaverProduct;
      
      if (ProductPage.current_variant.available && 
          ProductPage.current_variant_details.dropShip !== "T" && 
          !isBackorder) {
        if (instockMessage.length === 0) {
          $(".special-message").first().prepend('<p>In stock orders placed before 3pm CST will ship the same day.</p>');
        } else {
          instockMessage.show();
        }
      } else {
        instockMessage.hide();
      }

      if (
        ProductPage.current_variant_details.web_special_instructions.toLowerCase() != "false"
      ) {
        $("#web_special_instructions")
          .text(ProductPage.current_variant_details.web_special_instructions)
          .show();
        $("#form_qty_row_wrapper .flex").hide();
        $("#stock_status_msg").text("").hide();
        $(".special-message").hide();
        $(".dropshipMessage").hide();
        $("#product_ffi").hide();
        $(".add-to-quote-wrapper").show();
      } else if (
        (ProductPage.current_variant_details.seasonal_status.toLowerCase() == "ssnlphsout" ||
          ProductPage.current_variant_details.seasonal_status.toLowerCase() == "ssnlinact") &&
        ProductPage.current_variant_details.inventory_quantity <= 0
      ) {
        $("#web_special_instructions")
          .text("This item is temporarily unavailable. We are working on getting it back in stock.")
          .show();
        $("#form_qty_row_wrapper .flex").hide();
        $(".special-message").hide();
        $(".add-to-quote-wrapper").show();
        $(".dropshipMessage").show();
        $("#product_ffi").show();
      } else {
        $("#web_special_instructions").text("").hide();
        $("#form_qty_row_wrapper .flex").show();
        $(".special-message").show();
        $(".add-to-quote-wrapper").show();
        $(".dropshipMessage").show();
        $("#product_ffi").show();
      }

      $(".variant_cell").hide();
      $(".variant_cell_" + variant.id).show();
    };

    var updateClothingPromo = function (cart_items) {
      var wwfw_items = _.filter(cart_items, function (item) {
        return (
          item.product_type === "Clothing" || item.product_type === "Footwear"
        );
      });
      if (wwfw_items.length >= 1)
        var wwfw_total = _.reduce(
          wwfw_items,
          function (memo, item) {
            return memo + item.final_line_price;
          },
          0
        );
      var shipping_thresheold = $("#promo_clothing_card_body").attr(
        "data-shipping_threshold"
      );
      var shippign_check = shipping_thresheold - wwfw_total;
      if (shippign_check > 0) {
        var shipping_msg =
          "<p>You are " +
          Shopify.formatMoney(shippign_check) +
          ' away from Free Shipping! Shop more <a href="/collections/clothing">clothing</a> ';
        shipping_msg +=
          'or <a href="/collections/footwear">footwear</a> to add eligible products to your cart.</p>';
      } else {
        var shipping_msg =
          "<p><strong>You're eligible for free shipping!</strong></p>";
        shipping_msg +=
          "<p>Valid for $50+ Orders of Only Clothing and Footwear</p>";
      }
      $("#promo_clothing_card_body").html(shipping_msg);
    };

    var build_cart_success = function (item) {
      var avail_text = "";
      $.each(item.properties, function (indexInArray, valueOfElement) {
        avail_text = avail_text + " " + valueOfElement;
      });
      var variant_options = item.variant_options.join(", ");

      if (item.id == ProductPage.current_variant.id) {
        var qty_to_use = $("#quantity").val();
      } else {
        var qty_to_use = 1;
      }
      mini_cart_row = '<div class="row cart_dropdown_row">';
      mini_cart_row +=
        '<div class="col-2 text-center"><img src="' +
        item.image +
        '" alt="" class="img-fluid "/></div>';
      mini_cart_row += '<div class="col" id="add_item_details_col">';
      mini_cart_row +=
        "<h3>" +
        item.product_title +
        ' x <span class="cart_dropdown_items_added">' +
        qty_to_use +
        "</span> </h3>";
      if (variant_options != "Default Title" || !variant_options) {
        mini_cart_row +=
          '<p class="variant_options">' + variant_options + "</p>";
      }
      mini_cart_row +=
        '<p class="cart_dropdown_line_price">' +
        Shopify.formatMoney(item.price) +
        "</p>";
      mini_cart_row += '<p class="availability">Availability:';
      mini_cart_row +=
        '<span class="cart_dropdown_availability_msg">' +
        avail_text +
        "</span>";
      mini_cart_row += "</p>";
      mini_cart_row += "</div> </div>";
      return mini_cart_row;
    };

    var addProduct = function (formData) {
      //check if upsell products need to be added in and adjust data structure
      if ($(".checkbox_btn.checked").length > 0) {
        const original_item = {};
        $.each(formData, function (indexInArray, valueOfElement) {
          original_item[valueOfElement.name] = valueOfElement.value;
        });
        var items = [];
        items.push(original_item);
        $(".pdp_upsell_card").each(function (index, element) {
          if ($(element).find(".checkbox_btn").hasClass("checked")) {
            var item = {};
            item["id"] = $(element).find(".upsell_id").val();
            item["quantity"] = 1;
            var selected_variant_details = _.findWhere(upsellVariantDetails, {
              id: parseInt(item["id"]),
            });
            var selected_variant = _.findWhere(upsell_products[1].variants, {
              id: parseInt(item["id"]),
            });
            item["properties"] = {};
            item["properties"]["stock"] = selected_variant_details.stock_status;
            item["properties"]["clearance"] =
              selected_variant_details.clearance_msg;
            var extra_properties = check_extra_properties_upsell(
              selected_variant_details.tags
            );
            if (extra_properties) {
              item["properties"][extra_properties.name] =
                extra_properties.value;
            }
            console.log({
              item,
            });
            items.push(item);
            ga("send", "event", "PDP Upsell", "ATC", selected_variant.name);
          }
        });
        formData = {};
        formData.items = items;
      }
      //end of upsell product work
      $(".btn-atc").attr("disabled", "disabled").addClass("loading");
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        data: formData,
        success: function (data) {
          updateCartDrawer().then((r) => {
            openCartDrawer();
            $(".btn-atc").removeAttr("disabled").removeClass("loading");
          });

          jQuery.getJSON("/cart.js", function (cart) {
            ProductPage.cart = cart;
            updateCartItemCounts(cart.item_count);
            updateClothingPromo(cart.items);
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          $(".pdpCartError").text(XMLHttpRequest.responseJSON.description);
          $("#pdpGeneralModal").modal("show");
        },
      });
    };

    var bindUIActions = function () {
      $("#quantity").change(function (e) {
        e.preventDefault();
        if ($(this).val() == "10_plus") {
          $(".dropdown.show").removeClass("show").hide();
          var new_el =
            '<div class="form-group selector-wrapper">\
        <label for="quantity"> Quantity </label>\
        <input type="number" value="10" class="form-control" id="quantity" name="quantity"/>\
        </div>';
          $(".qty-selector").replaceWith(new_el);
        }

        var shipping_value_left = $(".promo_clothing_card .card-body").attr(
          "data-current-shipping-value-left"
        );
        wwfw_total = ProductPage.current_variant.price * $(this).val();
        var shipping_thresheold = $(".promo_clothing_card .card-body").attr(
          "data-shipping_threshold"
        );
        var shippign_check = shipping_thresheold - wwfw_total;
        if (shippign_check > 0) {
          var shipping_msg =
            "<p>You are " +
            Shopify.formatMoney(shippign_check) +
            ' away from Free Shipping! Shop more <a href="/collections/clothing">clothing</a> ';
          shipping_msg +=
            'or <a href="/collections/footwear">footwear</a> to add eligible products to your cart.</p>';
        } else {
          var shipping_msg =
            "<p><strong>You're eligible for free shipping!</strong></p>";
          shipping_msg +=
            "<p>Valid for $50+ Orders of Only Clothing and Footwear</p>";
        }
        $(".promo_clothing_card .card-body .pcc-txt").html(shipping_msg);
      });
      $("#place_partial_backorder").click(function (e) {
        e.preventDefault();
        $("#pdpPartialBoModal").modal("hide");
        addProduct(formData);
      });

      $(".add_in_stock").click(function (e) {
        e.preventDefault();
        $(this).closest(".gemplers-modal").modal("hide");
        //removing backorder Option;
        if (formData.items && formData.items.length > 1) {
          formData = formData.items[0];
          formData.quantity =
            ProductPage.current_variant_details.inventory_quantity;
        } else {
          formDataIndex = _.findIndex(formData, {
            name: "quantity",
          });
          formData[formDataIndex].value =
            ProductPage.current_variant_details.inventory_quantity;
        }

        addProduct(formData);
      });

      $("#place_backorder").click(function (e) {
        e.preventDefault();
        $("#pdpBackorderModal").modal("hide");
        addProduct(formData);
      });

      $selector_container = $(".add_to_cart_form");
      $(document).ready(function () {
        $("[single-product-selector]", $selector_container).on(
          "change",
          function () {
            var selectedValues = getProductOptions();
            var variants = ProductPage.product.variants;
            var variant = _.find(variants, function (variant) {
              return selectedValues.every(function (values) {
                return _.isEqual(variant[values.index], values.value);
              });
            });
            if (!variant) {
              return;
            }
            var variantDetails = _.findWhere(variantsDetails, {
              id: variant.id,
            });

            ProductPage.current_variant = variant;
            $("[variant-select]", $selector_container).val(variant.id);
            updatePrice();
            //update sold out
            updateImage();
            updateHistoryState();
            if (variantDetails) {
              ProductPage.current_variant_details = variantDetails;
              setUpProductPage();
            }
          }
        );
      });

      $("#atc_shipsaver").click(function (e) {
        e.preventDefault();
        var variantId = $(this).attr("data-variant_id");
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          data: {
            quantity: 1,
            id: variantId,
          },
          success: function (data) {
            $("#atc_shipsaver").replaceWith(
              '<div class="added"><strong>Added to your cart.</strong></div>'
            );
          },
          error: function (XMLHttpRequest, textStatus) {
            alert(
              "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
            );
          },
        });
      });
      var formData = [];
      $("#add_to_cart_form").on("submit", function (e) {
        e.preventDefault();

        formData = $(this).serializeArray();
        var quantity = parseInt(
          _.findWhere(formData, {
            name: "quantity",
          }).value
        );
        var avail_qty = parseInt(
          ProductPage.current_variant_details.inventory_quantity
        );

        var extra_properties = check_extra_properties(formData);

        if (
          ProductPage.current_variant_details.dropShip == "T" ||
          ProductPage.product.handle == "gemplers-shipping-saver"
        ) {
          var stock_status = {
            name: "properties[_stock]",
            value: ProductPage.current_variant_details.stock_status.replace(
              "Add to Cart - ",
              ""
            ),
          };
          formData.unshift(stock_status);
          addProduct(formData);
        } else if (
          quantity > avail_qty &&
          ProductPage.current_variant_details.web_backorder_notes.toLowerCase() ==
            "false"
        ) {
          if (avail_qty > 0) {
            if (
              ProductPage.current_variant_details.inventory_policy == "deny"
            ) {
              $(".pdp_bo_requested").text(quantity);
              $(".pdp_bo_available").text(
                ProductPage.current_variant_details.inventory_quantity
              );
              var stock_status = {
                name: "properties[_stock]",
                value: ProductPage.current_variant_details.stock_status.replace(
                  "Add to Cart - ",
                  ""
                ),
              };
              formData.unshift(stock_status);
              $("#pdpPrtialAvailableModal").modal("show");
              var clearance_msg = {
                name: "properties[_clearance]",
                value: ProductPage.current_variant_details.clearance_msg,
              };
              formData.unshift(clearance_msg);
            } else {
              $(".pdp_bo_msg").text(
                ProductPage.current_variant_details.alt_stock_status
              );
              $(".pdp_bo_requested").text(quantity);
              $(".pdp_bo_available").text(
                ProductPage.current_variant_details.inventory_quantity
              );
              var qty_to_bo =
                quantity -
                ProductPage.current_variant_details.inventory_quantity;
              formData = {
                items: [
                  {
                    quantity:
                      ProductPage.current_variant_details.inventory_quantity,
                    id: ProductPage.current_variant_details.id,
                    properties: {
                      stock: ProductPage.current_variant_details.stock_status,
                      clearance:
                        ProductPage.current_variant_details.clearance_msg,
                    },
                  },
                  {
                    quantity: qty_to_bo,
                    id: ProductPage.current_variant_details.id,
                    properties: {
                      stock:
                        ProductPage.current_variant_details.alt_stock_status,
                    },
                  },
                ],
              };
              $("#pdpPartialBoModal").modal("show");
            }
          } else {
            var stock_status = {
              name: "properties[_stock]",
              value: ProductPage.current_variant_details.stock_status.replace(
                "Add to Cart - ",
                ""
              ),
            };
            formData.unshift(stock_status);
            var clearance_msg = {
              name: "properties[_clearance]",
              value: ProductPage.current_variant_details.clearance_msg,
            };
            formData.unshift(clearance_msg);
            $(".pdp_bo_msg").text(
              ProductPage.current_variant_details.stock_status
            );
            $("#pdpBackorderModal").modal("show");
          }
        } else {
          var stock_status = {
            name: "properties[_stock]",
            value: ProductPage.current_variant_details.stock_status.replace(
              "Add to Cart - ",
              ""
            ),
          };
          formData.unshift(stock_status);
          var clearance_msg = {
            name: "properties[_clearance]",
            value: ProductPage.current_variant_details.clearance_msg,
          };
          formData.unshift(clearance_msg);
          addProduct(formData);
        }
      });
      $(".carousel-mip").flickity({
        cellSelector: ".carousel-cell",
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
      });
      $(".carousel-mip-nav").flickity({
        asNavFor: ".carousel-mip",
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
      });
      updateImage();
      $("#cart_dropdown_close").click(function (e) {
        e.preventDefault();
        $(".cart_dropdown").removeClass("active_cart_dropdown");
        $(".variant_options").hide();
      });
    };

    ProductPage.init = function () {
      // Get Product JSON data
      ProductPage.product = JSON.parse(
        document.getElementById("ProductJson").innerHTML
      );
      ProductPage.productOptions = getProductOptions();
      ProductPage.cart = JSON.parse(
        document.getElementById("CartJson").innerHTML
      );
      ProductPage.discountData = JSON.parse(
        document.getElementById("DiscountJson").innerHTML
      );
      ProductPage.discountProductEligibleData = JSON.parse(
        document.getElementById("DiscountProductEligibleJson").innerHTML
      );

      var variants = ProductPage.product.variants;
      console.log(variants);
      pdp_utilities();
      var variant = _.find(variants, function (variant) {
        return ProductPage.productOptions.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      if (variantsDetails) {
        ProductPage.current_variant_details = _.findWhere(variantsDetails, {
          id: variant.id,
        });
        var cart_variants = _.where(ProductPage.cart.items, {
          variant_id: variant.id,
        });
        if (cart_variants.length > 0) {
          var cart_qty = _.pluck(cart_variants, "quantity");
          var cart_qty = _.reduce(
            cart_qty,
            function (memo, num) {
              return memo + num;
            },
            0
          );
          ProductPage.current_variant_details.inventory_quantity =
            ProductPage.current_variant_details.inventory_quantity - cart_qty;
        }
      }
      ProductPage.current_variant = variant;

      bindUIActions();
      setUpProductPage();
      $(function () {
        $(window).scroll(function () {
          $(document).scrollTop() > 800
            ? $(".pdp-sticky-selector").addClass("shown")
            : $(".pdp-sticky-selector").removeClass("shown");
        });
      });

      setDiscountLabels();
    };
  })((window.ProductPage = window.ProductPage || {}), jQuery);

const setDiscountLabels = () => {
  $(".option-label").each(function () {
    const index = Number($(this).data("option-index"));
    const value = String($(this).data("value"));

    if (index === 1) {
      if (uniqueVariantCloseoutOption_1.includes(value)) {
        $(this).addClass("marked");
      }
      if (uniqueVariantSaleOption_1.includes(value)) {
        $(this).addClass("marked");
      }
    } else if (index === 2) {
      if (uniqueVariantCloseoutOption_2.includes(value)) {
        $(this).addClass("marked");
      }
      if (uniqueVariantSaleOption_2.includes(value)) {
        $(this).addClass("marked");
      }
    } else {
      if (uniqueVariantCloseoutOption_3.includes(value)) {
        $(this).addClass("marked");
      }
      if (uniqueVariantSaleOption_3.includes(value)) {
        $(this).addClass("marked");
      }
    }
  });
};


var header = document.querySelector(".global-header");
var menu = document.getElementById("l1_menu");
var topMenu = document.querySelector(".top-menu");
var sticky = header.offsetTop;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let isStickyHidden = false;
let oldValue = 0;
let scrollTimeout = null;
const parentLiElements = document.querySelectorAll(".parent-li");

function safariScrollFix(newValue) {
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  
  if (newValue <= 0) {
    menu.classList.remove("sticky-hide");
    topMenu.classList.remove("sticky-hide");
    isStickyHidden = false;
    return true;
  }
  
  if (newValue >= maxScroll - 1) {
    return true; 
  }
  
  return false;
}

const navOverlay = document.getElementById("nav-site-overlay");

function handleMouseEnter(element) {
  window.removeEventListener("scroll", scrollHandler);
  const childMenu = element.querySelector("ul.child");
  if (childMenu) {
    navOverlay.style.display = "block";
  }
}

function handleMouseLeave() {
  window.addEventListener("scroll", scrollHandler);
  navOverlay.style.display = "none";
}

parentLiElements.forEach((element) => {
  element.addEventListener("mouseenter", () => handleMouseEnter(element));
  element.addEventListener("mouseleave", handleMouseLeave);
});

function scrollHandler(e) {
  var childMenus = document.querySelectorAll("ul.child");
  childMenus.forEach(function (menu) {
  });
  
  if (isSafari && scrollTimeout) {
    clearTimeout(scrollTimeout);
  }
  
  var newValue = window.pageYOffset || document.documentElement.scrollTop;
  // console.log('isSafari: ', isSafari, 'newValue:', newValue, 'oldValue:', oldValue);
  
  if (isSafari) {
    scrollTimeout = setTimeout(() => {
      processSafariScroll(newValue);
    }, 10);
  } else {
    processScroll(newValue);
  }
}

function processSafariScroll(newValue) {
  if (safariScrollFix(newValue)) {
    oldValue = newValue;
    return;
  }
  
  processScroll(newValue);
}

function processScroll(newValue) {
  const scrollDifference = oldValue - newValue;
  const tolerance = isSafari ? 2 : 0; // Increased tolerance for Safari
  
  if (scrollDifference < -tolerance) {
    // down
    header.classList.add("sticky");
    menu.classList.add("sticky-hide");
    topMenu.classList.add("sticky-hide");
    isStickyHidden = true;
  } else if (scrollDifference > tolerance) {
    // up
    menu.classList.remove("sticky-hide");
    topMenu.classList.remove("sticky-hide");
    isStickyHidden = false;
  }
  
  oldValue = newValue;
}

document.addEventListener("DOMContentLoaded", (event) => {
  window.addEventListener("scroll", scrollHandler, { passive: true });
});
